import { CSSProperties } from "react";
import { PlusCircleOutlined } from "@ant-design/icons";

interface IProps {
  onPress: () => void;
  style?: CSSProperties;
}

export default function AddLinkedNodeButton({
  onPress,
  style,
}: IProps) {
  const handlePress = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    onPress?.();
  }

  return (
    <button
      onClick={handlePress}
      style={{
        position: "absolute",
        zIndex: 5,
        border: "1px solid #8492A6",
        borderRadius: 4,
        background: "#FFFFFF",
        boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
        cursor: "pointer",
        ...style
      }}
    >
      <PlusCircleOutlined style={{ color: '#212121' }} />
    </button>
  )
}
